export default "__VITE_ASSET__DlbGR12C__"